import React from 'react';
import PropTypes from 'prop-types';

const STEP_BENEFITS = {
  about_you: {
    className: 'bg-teal-100 border-easter',
    text:
      'A clear introduction helps other members recognise you and builds trust from the first connection.',
  },
  work: {
    className: 'bg-squeeze border-violet',
    text:
      'Your experience and goals help us match you with relevant people, markets, and opportunities.',
  },
  connect: {
    className: 'bg-lily border-valencia',
    text:
      'Your interests help us personalise the content, events, and community recommendations you see.',
  },
};

const StepHeading = ({ isPeriodicReview, isSinglePage, step }) => (
  <div className="mb-8 text-center sm:text-left">
    <p className="uppercase tracking-wider text-easter text-xs font-semibold mb-2">
      {step.eyebrow}
    </p>
    <h2 className="text-2lg text-ebony mb-2">
      {isSinglePage && isPeriodicReview
        ? 'Keep your profile up to date'
        : step.title}
    </h2>
    <p className="text-dusty text-sm max-w-140">{step.description}</p>
    {!isPeriodicReview && (
      <div
        className={`border-l-4 rounded mt-5 px-4 py-3 text-left ${
          STEP_BENEFITS[step.key]?.className || 'bg-teal-100 border-easter'
        }`}
      >
        <p className="text-xs uppercase tracking-wider font-semibold text-ebony mb-1">
          Why this matters
        </p>
        <p className="text-sm text-dusty">
          {STEP_BENEFITS[step.key]?.text || step.description}
        </p>
      </div>
    )}
  </div>
);

StepHeading.propTypes = {
  isPeriodicReview: PropTypes.bool.isRequired,
  isSinglePage: PropTypes.bool.isRequired,
  step: PropTypes.object.isRequired,
};

export default StepHeading;
